module.exports = __webpack_public_path__ + "static/img/IMG_20241027_160849.194d3b16.jpg";